import { Fade, IconButton, LinearProgress, Tooltip } from '@material-ui/core';
import ImageWrapper from 'components/ImageWrapper';
import ExtractOutlineIcon from 'images/icons/objects/clocks/clockArrowBackDarkGrayOutline.svg';
import PrintLabelProductOutlineIcon from 'images/icons/objects/printers/printerYellowOutline.svg';
import PrintLabelProductDisabledIcon from 'images/icons/objects/printers/printerLightGrayOutline.svg';
import DeleteProductOutlineIcon from 'images/icons/signals/removesAndDeletes/newTrash.svg';
import { useHistory } from 'react-router-dom';
import ValidationLength from 'utils/utils';
import { ProductTable } from '../../styles';

function DesktopProductsTable({
  mainLoading,
  products,
  getId,
  setModalSettings,
  modalSettings,
  isLabelAdmin,
  labelManagerHasAllPermissions,
  isLabelUser,
  setFlags
}) {
  const history = useHistory();

  const getValidityText = (p) => {
    const type = (p?.expirationType || '').toString().toUpperCase();
    const hasNewField =
      p?.expirationDuration !== undefined && p?.expirationDuration !== null;
    const dur = hasNewField ? Number(p.expirationDuration) : null;

    if (type === 'HOUR') {
      return dur > 0 ? `${dur} ${dur !== 1 ? 'horas' : 'hora'}` : '-';
    }

    if (type === 'DAY') {
      if (hasNewField) {
        return `${dur} ${dur === 1 ? 'dia' : 'dias'}`;
      }
    }

    if (p?.quantityValidDays !== undefined && p?.quantityValidDays !== null) {
      const legacy = Number(p.quantityValidDays);
      return `${legacy} ${legacy === 1 ? 'dia' : 'dias'}`;
    }

    return '-';
  };

  return (
    <ProductTable
      className="desktop"
      cellPadding="0"
      cellSpacing="0"
      border="0"
    >
      <thead>
        <tr className="headerTitle">
          <th className="imageColumn subtitle pr8 pl8">&nbsp;</th>

          <th
            style={{ width: isLabelAdmin ? '24%' : '30%' }}
            className="descriptionColumn subtitle pr8 pl8"
          >
            PRODUTO
          </th>

          <th className="unitColumn subtitle center pr8 pl8">UN.</th>

          {isLabelAdmin && (
            <th className="flagsColumn subtitle pr8 pl8">MARCAS</th>
          )}

          <th
            style={{ width: isLabelAdmin ? '15%' : '17%' }}
            className="categoryColumn subtitle pr8 pl8"
          >
            CATEGORIA
          </th>

          <th
            style={{ width: isLabelAdmin ? '15%' : '19%' }}
            className="conservationColumn subtitle pr8 pl8"
          >
            ESTADO DE CONSERVAÇÃO
          </th>

          <th className="validityColumn subtitle left pr8 pl8">VALIDADE</th>

          {!isLabelAdmin && (
            <th className="maturityColumn subtitle center pr8 pl8">
              VENCIMENTO
            </th>
          )}

          <th
            style={{ width: isLabelAdmin ? '2%' : '4%' }}
            className="iconsColumn subtitle left pr8 pl8"
          />
        </tr>
      </thead>

      <tbody>
        {mainLoading && (
          <tr>
            <th colSpan={!isLabelAdmin ? 9 : 8} className="m10 textAlignCenter">
              <LinearProgress
                style={{ height: '7px' }}
                id="loading"
                variant="query"
              />
            </th>
          </tr>
        )}

        {products?.length ? (
          products.map((product) => {
            const labelCountObj = [
              {
                type: 'expired',
                count: product?.expiredCount
              },
              {
                type: 'onDate',
                count: product?.onDateCount
              },
              {
                type: 'valid',
                count: product?.validCount
              }
            ];

            return (
              <>
                <tr className="lineBorder">
                  <td className="description dFlex alignCenter pt8 pr8 pb8 pl8">
                    <ImageWrapper
                      width="34px"
                      height="34px"
                      url={product?.image?.url}
                      borderType={product?.type}
                    />
                  </td>

                  <td className="description left pr8 pl8">
                    <span
                      className="cursorPointer lightBlue"
                      onClick={() => {
                        history.push(
                          `/etiquetas/catalogo/produtos/${getId}/${product?.id}`
                        );
                        setModalSettings(
                          modalSettings.map((modal) =>
                            modal.name === 'productDialog'
                              ? { ...modal, open: true }
                              : modal
                          )
                        );
                      }}
                    >
                      {ValidationLength(product?.description, 50)}
                    </span>
                  </td>

                  <td className="description center pr8 pl8">
                    {product?.consumptionUnitsPrimary?.abbreviation}
                  </td>

                  {isLabelAdmin && (
                    <td
                      className="description pr8 pl8"
                      style={{
                        borderLeft: 'solid 1px rgba(208, 211, 226, 1)'
                      }}
                    >
                      <Tooltip
                        TransitionComponent={Fade}
                        TransitionProps={{ timeout: 600 }}
                        title={
                          product?.flags?.length ? (
                            product.flags.map((flag, index) => (
                              <p
                                style={{
                                  marginBottom:
                                    product?.flags?.length - 1 === index
                                      ? '0'
                                      : '5px'
                                }}
                              >
                                {flag.description}
                              </p>
                            ))
                          ) : (
                            <p className="mb0">Nenhum registro</p>
                          )
                        }
                      >
                        <span className="fontSizeDefault">
                          {product?.flags?.length || 0}
                        </span>
                      </Tooltip>
                    </td>
                  )}

                  <td
                    style={{
                      borderLeft: 'solid 1px rgba(208, 211, 226, 1)'
                    }}
                    className="description left pr8 pl8"
                  >
                    {ValidationLength(
                      product?.categories?.description || '-',
                      25
                    )}
                  </td>

                  <td
                    style={{
                      borderLeft: 'solid 1px rgba(208, 211, 226, 1)'
                    }}
                    className="description left pr8 pl8"
                  >
                    {ValidationLength(
                      product?.conservation?.description || '-',
                      25
                    )}
                  </td>

                  <td
                    className={`description left pr8 pl8 ${product?.labelStatus?.toLowerCase()}`}
                    style={{
                      borderLeft: 'solid 1px rgba(208, 211, 226, 1)'
                    }}
                  >
                    <span>
                      {getValidityText(product)}
                    </span>
                  </td>

                  {!isLabelAdmin && (
                    <td
                      className="description right pr8 pl8"
                      style={{
                        borderLeft: 'solid 1px #860891'
                      }}
                    >
                      <div className="labelCountContainer">
                        {labelCountObj?.map((label) => (
                          <div
                            className={`labelCountItem ${
                              label?.count && 'hasValue'
                            } ${label?.type}`}
                          >
                            <span>{label?.count || '-'}</span>
                          </div>
                        ))}
                      </div>
                    </td>
                  )}

                  <td
                    className="iconsColumnValues description pt8 pr8 pb8 pl8"
                    style={{
                      borderLeft: 'solid 1px #333541'
                    }}
                  >
                    <div
                      className="dFlex alignCenter justifyCenter"
                      style={{ gap: '8px' }}
                    >
                      {!isLabelAdmin && (
                        <>
                          <IconButton
                            onClick={() => {
                              if (!product?.canPrintLabel) return;

                              setModalSettings(
                                modalSettings.map((modal) =>
                                  modal.name === 'labelPrintConfigDialog'
                                    ? { ...modal, open: true, product }
                                    : modal
                                )
                              );
                            }}
                            style={{ padding: 0, outline: 0 }}
                          >
                            <img
                              src={
                                !product?.canPrintLabel
                                  ? PrintLabelProductDisabledIcon
                                  : PrintLabelProductOutlineIcon
                              }
                              alt="PrintLabelProductIcon"
                            />
                          </IconButton>

                          <IconButton
                            aria-label="delete"
                            onClick={() => {
                              setModalSettings(
                                modalSettings.map((modal) =>
                                  modal.name === 'stockExtractDialog'
                                    ? {
                                        ...modal,
                                        initialProduct: product || null,
                                        open: true
                                      }
                                    : modal
                                )
                              );
                            }}
                            style={{ padding: 0, outline: 0 }}
                          >
                            <img src={ExtractOutlineIcon} alt="ExtractIcon" />
                          </IconButton>
                        </>
                      )}

                      {(isLabelAdmin || labelManagerHasAllPermissions) && (
                        <IconButton
                          aria-label="delete"
                          onClick={() => {
                            setFlags(product?.flags);
                            setModalSettings(
                              modalSettings.map((modal) =>
                                modal.name === 'confirmDeleteDialog'
                                  ? {
                                      ...modal,
                                      open: true,
                                      product,
                                      title: `Deseja realmente excluir ${product?.description}?`,
                                      customClass:
                                        'deleteProductConfirmationDialog',
                                      onClose: () =>
                                        setModalSettings(
                                          modalSettings.map((modal) =>
                                            modal.name === 'confirmDeleteDialog'
                                              ? {
                                                  ...modal,
                                                  open: false,
                                                  product: null,
                                                  customClass: '',
                                                  title: '',
                                                  content: '',
                                                  onConfirm: '',
                                                  onClose: ''
                                                }
                                              : modal
                                          )
                                        )
                                    }
                                  : modal
                              )
                            );
                          }}
                          style={{ padding: 0, outline: 0 }}
                        >
                          <img
                            className="deleteProductIcon"
                            src={DeleteProductOutlineIcon}
                            alt="DeleteProductIcon"
                          />
                        </IconButton>
                      )}
                    </div>
                  </td>
                </tr>

                <tr>
                  <td
                    colSpan={!isLabelAdmin ? 9 : 8}
                    className="m10 textAlignCenter"
                  >
                    <hr style={{ marginTop: '-1px' }} />
                  </td>
                </tr>
              </>
            );
          })
        ) : (
          <tr>
            <th colSpan={!isLabelAdmin ? 9 : 8} className="m10 textAlignCenter">
              Não há nenhum produto.
            </th>
          </tr>
        )}
      </tbody>
    </ProductTable>
  );
}

export default DesktopProductsTable;
